import { Customer } from "../../customer/shared/customer.model";
import { Dealer } from "../../dealer/shared/dealer.model";
import { BaseModel } from "../../shared/base.model";
import { DateUtil } from "../../shared/date_util";

export class TransferredDrone extends BaseModel {
    private _drone_id: number = -1;
    private _transferred_to_type: number = -1;
    private _transferred_to_id: number = -1;
    private _transferred_date: Date = new Date();
    private _dealer: Dealer | null = null;
    private _customer: Customer | null = null;

    public get drone_id(): number {
        return this._drone_id;
    }

    public set drone_id(value: number) {
        this._drone_id = value;
    }

    public get transferred_to_type(): number {
        return this._transferred_to_type;
    }

    public set transferred_to_type(value: number) {
        this._transferred_to_type = value;
    }

    public get transferred_to_id(): number {
        return this._transferred_to_id;
    }

    public set transferred_to_id(value: number) {
        this._transferred_to_id = value;
    }

    public get transferred_date(): Date {
        return this._transferred_date;
    }

    public set transferred_date(value: Date) {
        this._transferred_date = DateUtil.getDateFromValue(value);
    }

    public get dealer(): Dealer | null {
        return this._dealer;
    }

    public set dealer(value: Dealer) {
        this._dealer = value;
    }

    public get customer(): Customer | null {
        return this._customer;
    }

    public set customer(value: Customer) {
        this._customer = value;
    }

    public static toTransferredDrones(obj: string | Object[]): TransferredDrone[] {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let transferredDrones: TransferredDrone[] = [];

        for (const o2 of (<Object[]>obj2)) {
            transferredDrones.push(TransferredDrone.toTransferredDrone(o2));
        }

        return transferredDrones;
    }

    public static toTransferredDrone(obj: string | Object): TransferredDrone {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of TransferredDrone.
        let transferredDrone: TransferredDrone = Object.assign(new TransferredDrone(), obj2);

        if (transferredDrone.dealer != null) {
            transferredDrone.dealer = Dealer.toDealer(transferredDrone.dealer);
        } else if (transferredDrone.customer != null) {
            transferredDrone.customer = Customer.toCustomer(transferredDrone.customer);
        }

        return transferredDrone;
    }
}